import { useContext } from "react";
import {
  BrowserRouter as Router,
  Redirect,
  Route,
  Switch,
} from "react-router-dom";
import DashboardLayout from "./layouts/DashboardLayout";
import AuthLayout from "./layouts/AuthLayout";
import WebpayErrorRedirect from "./components/webpayError/WebpayErrorRedirect";
import { Layouts } from "./config/constants";
import { PortalConfigContext } from "./providers/PortalConfigProvider";

function AppRouter() {
  const portalConfig = useContext(PortalConfigContext);
  return (
    <Router>
      <Switch>
        <Route path="/webpayError" render={() => <WebpayErrorRedirect />} />
        {!!portalConfig.login && (
          <Route
            path={Layouts.AUTH}
            render={(props: any) => <AuthLayout {...props} />}
          />
        )}
        <Route
          path={Layouts.DASHBOARD}
          render={(props: any) => (
            <DashboardLayout layout={Layouts.DASHBOARD} {...props} />
          )}
        />
        <Route
          path={Layouts.USER_DASHBOARD}
          render={(props: any) => (
            <DashboardLayout layout={Layouts.USER_DASHBOARD} {...props} />
          )}
        />
        <Route
          path={Layouts.PAYMENT_HISTORY}
          render={(props: any) => (
            <DashboardLayout layout={Layouts.PAYMENT_HISTORY} {...props} />
          )}
        />
        <Redirect
          from="*"
          to={portalConfig.login ? "/auth/index" : "/dashboard/index"}
        />
      </Switch>
    </Router>
  );
}

export default AppRouter;
